export default __webpack_public_path__ + "media/images/previous_blue_arrow_16-3e91a3e87b0ee77646ea4c40e973589e.png";